import React from 'react';
import './PriceMatchChipBar.css';

const PriceMatchChipBar = ({
  active,
  count,
  onToggle,
  hintWhenActive = true,
  hintExtra = null,
}) => {
  return (
    <div className="price-match-chip-bar">
      <button
        type="button"
        className={`price-match-chip${active ? ' price-match-chip--active' : ''}`}
        aria-pressed={active}
        onClick={onToggle}
      >
        <span className="price-match-chip-dot" aria-hidden="true" />
        Hotpoint price match
        <span className="price-match-chip-count">{count}</span>
      </button>
      {active && hintWhenActive ? (
        <p className="price-match-chip-hint">
          Showing Hotpoint products with verified competitor savings
          {hintExtra}
        </p>
      ) : null}
    </div>
  );
};

export default PriceMatchChipBar;
